export const statusIcons = [
  {
    status: 'A SALVO LOS DERECHOS',
    icon: 'check',
    color: 'success',
    type: 'subtle-success'
  },
  {
    status: 'ARCHIVO PROVISIONAL',
    icon: ['fas', 'archive'],
    color: 'info',
    type: 'subtle-info'
  },
  {
    status: 'CONCILIADA',
    icon: ['fas', 'check-circle'],
    type: 'subtle-success',
    color: 'success'
  },
  {
    status: 'CONCLUIDA',
    icon: ['fas', 'check-double'],
    color: 'secondary',
    type: 'subtle-secondary'
  },
  {
    status: 'EN PROCESO',
    type: 'subtle-primary',

    icon: ['far', 'folder-open'],
    color: 'primary'
  },
  {
    status: 'POSIBLE INFRACCION A LA LEY',
    icon: ['fas', 'check-double'],
    color: 'warning',
    type: 'subtle-warning'
  }
];
